module.exports = __webpack_public_path__ + "static/media/Rectangle 6.f5dd9a4f.svg";